import { jsx as u } from "react/jsx-runtime";
import { useOfferStore as f } from "../../store/index.mjs";
import { STRIPE_KEY_DEV as S } from "./constants/stripe-keys-dev.mjs";
import { loadStripe as P } from "../../node_modules/@stripe/stripe-js/dist/pure.mjs";
import { useState as d, useMemo as a, useEffect as c, createContext as v, useContext as x } from "react";
import { isStripePaymentMethodUsingPaymentElement as E } from "./util/is-stripe-payment-method-using-payment-element.mjs";
const m = v(void 0);
function _() {
  const t = x(m);
  if (!t) throw new Error("useStripeProvider must be used within a StripeContext.Provider");
  return t;
}
function g({
  children: t,
  publishableKey: o,
  stripeAccountId: e,
  forceLoad: i
}) {
  const [s, p] = d(null), { paymentMethod: r } = f(), n = a(
    () => r && E(r) || i,
    [i, r]
  );
  return c(() => {
    n && e && p(
      P(o || S, {
        stripeAccount: e
      })
    );
  }, [o, n, e]), /* @__PURE__ */ u(
    m.Provider,
    {
      value: {
        stripePromise: s
      },
      children: t
    }
  );
}
export {
  g as StripeProvider,
  _ as useStripeProvider
};
